import { render, staticRenderFns } from "./ProvinceSelect.vue?vue&type=template&id=48ecbc22&scoped=true"
import script from "./ProvinceSelect.vue?vue&type=script&lang=js"
export * from "./ProvinceSelect.vue?vue&type=script&lang=js"
import style0 from "./ProvinceSelect.vue?vue&type=style&index=0&id=48ecbc22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ecbc22",
  null
  
)

export default component.exports